var _path, _ellipse, _ellipse2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cc-face-happy",
    d: "M23.9,47.8C37,47.8,47.7,37,47.7,23.9C47.7,10.7,37,0,23.9,0S0,10.7,0,23.9C0,37,10.7,47.8,23.9,47.8z",
    fill: "#AEAEAE"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.9,
    cy: 17.9,
    rx: 4.3,
    ry: 6
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.7,
    cy: 17.9,
    rx: 4.3,
    ry: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25,37.8c-5.2,0-10.1-3-13.1-8l0.4-0.4c2.9,4.9,7.6,7.8,12.7,7.8c5.1,0,9.8-2.9,12.7-7.8l0.4,0.4                 C35.2,34.8,30.3,37.8,25,37.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25,37.8c-5.2,0-10.1-3-13.1-8l0.4-0.4c2.9,4.9,7.6,7.8,12.7,7.8c5.1,0,9.8-2.9,12.7-7.8l0.4,0.4             C35.2,34.8,30.3,37.8,25,37.8z",
    stroke: "#000000",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceHappy);
export default __webpack_public_path__ + "static/media/face-happy.3a4a506c5ee0288e80852ab80e922993.svg";
export { ForwardRef as ReactComponent };